import { cast } from 'mobx-state-tree';
import { batches_for_timetable_selectQuery } from '@app-types/graphql-types';
import { TimetableModelType } from '../../Timetable';

export const setBatch = ({
  self,
  batch,
}: {
  batch: batches_for_timetable_selectQuery['active_batch'][0] | null;
  self: Partial<TimetableModelType>;
}) => {
  self.selectedTimelineItem = undefined;
  self.timeSlotConfigurationsLoaded = false;
  self.timeSlotConfigurations = null;
  // If we don't set the groups to null first, when we change the batch, the timetable will try to re render with the new batch data
  // and the old groups. For some reason the timeline plugin tries to access groups using new keys and with old groups data.
  // since the old group data does not have the new keys, it fails.
  self.timelineGroups = null;

  if (!batch) {
    self.batch = null;
  } else {
    self.batch = {
      id: batch.id,
      name: batch.name,
      year: batch.year,
      batch_classes: cast(batch.batch_classes || []),
      intake: {
        id: batch?.intake?.id || '',
        name: batch?.intake?.name || '',
      },
    };
  }
};
